import React, { useState } from "react";
import loadingImg from "./../../Assets/Image/LoadingSpin.gif";
import clock from "./../../Assets/Icons/clock.png";
import warning from "./../../Assets/Icons/warning-sign.png";
import down from "./../../Assets/Icons/down.png";
import { getFoodStatus } from "./foodItemLogic";
import "./FoodItem.css";
import { toast } from "react-toastify";
import HomeCookAllergyModal, {
  getHomeCookAllergyNote,
} from "../HomeCookAllergyModal/HomeCookAllergyModal";

export default function FoodActionButton({
  loading,
  food,
  mode,
  totalPrice,
  handleSave,
  isPreview,
  setShowUnavailableReasonModal,
  setShowOutOfHourModal,
  userDetails,
  showModalInfo,
  onAfterSaveInSearch,
}) {
  const [showHomeCookAllergyModal, setShowHomeCookAllergyModal] = useState(false);
  const foodStatus = getFoodStatus(food?.isActive, food?.status);

  const completeSave = async (cartMeta = {}) => {
    await handleSave(cartMeta);

    if (typeof onAfterSaveInSearch === "function") {
      onAfterSaveInSearch();
    }
  };

  const handleAddToCartClick = () => {
    if (userDetails.UserName === undefined) {
      toast.warning("Please login !!");
      showModalInfo();
      return;
    }

    if (mode !== "edit" && food?.isHomeCook === true) {
      setShowHomeCookAllergyModal(true);
      return;
    }

    completeSave();
  };

  const handleAllergyConfirm = async () => {
    setShowHomeCookAllergyModal(false);
    await completeSave({
      isConfirm: true,
      allergyNote: getHomeCookAllergyNote(food?.itemName),
    });
  };

  if (loading) {
    return (
      <button
        className="btn-addtocart"
        type="button"
        style={{ pointerEvents: "none", cursor: "no-drop" }}
      >
        <img
          src={loadingImg}
          className="img-fluid"
          style={{ height: "1rem" }}
          alt="loading"
        />
      </button>
    );
  }

  if (foodStatus === "Unavailable") {
    return (
      <button
        className="btn-addtocart d-flex justify-content-center align-items-center add-btn-disabled"
        type="button"
        onClick={() => setShowUnavailableReasonModal(true)}
      >
        <div className="icon-container icon-no-background">
          <img src={warning} alt="warning" />
        </div>
        <div className="mx-2">Unavailable</div>
        <div className="icon-container icon-no-background">
          <img src={down} alt="down" />
        </div>
      </button>
    );
  }

  if (foodStatus === "Out of hour") {
    return (
      <button
        className="btn-addtocart d-flex justify-content-center align-items-center add-btn-disabled"
        type="button"
        onClick={() => setShowOutOfHourModal(true)}
      >
        <div className="icon-container">
          <img src={clock} alt="clock" />
        </div>
        <div className="mx-2">Out of hour</div>
        <div className="icon-container icon-no-background">
          <img src={down} alt="down" />
        </div>
      </button>
    );
  }

  if (food.isPreview === true || isPreview) {
    return (
      <button
        className="btn-addtocart d-flex justify-content-center align-items-center add-btn-disabled"
        type="button"
      >
        <div className="mx-2">Preview</div>
      </button>
    );
  }

  if (totalPrice === 0) {
    return (
      <button
        className="btn-addtocart d-flex justify-content-center align-items-center add-btn-disabled"
        type="button"
      >
        <div className="mx-2">Add to Cart For £{totalPrice.toFixed(2)}</div>
      </button>
    );
  }

  return (
    <>
      <button
        className="btn-addtocart"
        type="button"
        onClick={handleAddToCartClick}
      >
        {mode === "edit" ? "Update Item For" : "Add to Cart For"} £
        {totalPrice.toFixed(2)}
      </button>

      <HomeCookAllergyModal
        show={showHomeCookAllergyModal}
        foodItemName={food?.itemName}
        foodImage={food?.foodItemImages?.[0]?.itemImagePath}
        onConfirm={handleAllergyConfirm}
        onClose={() => setShowHomeCookAllergyModal(false)}
        isLoading={loading}
      />
    </>
  );
}
